<script>
  import http from '@/service/http'
  import { mapState } from 'vuex'

  export default {
    name: 'Form',
    data () {
      return {
        unidades: [{}],
        familia: {
          id: '',
          familia: '',
          categorias: []
        }
      }
    },
    mounted () {
      this.fecth()
    },
    watch: {
      '$route' () {
        if (this.$route.params.id != null) {
          this.fecth()
        }
      },
      hasAll () {
        if (this.hasAll) {
          this.all = true
        } else {
          this.all = false
        }
      }
    },
    methods: {
      validate: function () {
        this.$validator.validateAll().then(success => {
          if (!success) {
            return false
          } else {
            this.submit()
          }
        })
      },
      async submit () {
        const verb = this.isNew ? 'post' : 'put'
        const url = this.isNew ? '/familias' : `/familias/${this.familia.id}`
        const {data} = await http[verb](url, this.familia)
        if (data != null) {
          this.$emit('update-familias-list', {familia: data.familia})
          this.$router.push({name: 'familias.index'})
        }
      },
      async fecth () {
        this.clear()
        const {id} = this.$route.params
        if (id !== undefined) {
          const {data} = await http.get(`/familias/${id}/edit`)
          this.familia = data.familia
          this.unidades = data.unidades
          setTimeout(function () {
            window.Materialize.updateTextFields()
          }, 0)
        }
      },
      clear () {
        this.familia = {
          id: '',
          familia: '',
          categorias: []
        }
      },
      addCategoria () {
        this.familia.categorias.push({categoria: ''})
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      },
      destroyCategoria (index) {
        this.$swal({
          title: 'Atenção',
          text: `excluir uma categoria é uma operação irreversível`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(async () => {
          if (!this.familia.categorias[index].id) {
            this.familia.categorias.splice(index, 1)
            window.Materialize.toast('Categoria excluído!', 4000)
          } else {
            await http.delete(`familias/categorias/${this.familia.categorias[index].id}`)
            this.familia.categorias.splice(index, 1)
            window.Materialize.toast('Categoria excluído!', 4000)
          }
        })
      }
    },
    computed: {
      ...mapState(['loading']),
      isNew () {
        return this.familia.id === ''
      },
      api_url () {
        return process.env.UPLOADS_URL
      }
    }
  }
</script>

<template>
  <div>

    <form @submit.prevent="validate">

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <div>

            <div class="row">
              <div class="input-field col s12">
                <input name="familia" id="familia" type="text" v-validate
                       data-vv-rules="required" :class="{invalid: errors.has('familia')}"
                       v-model="familia.familia"/>
                <label for="familia">*Família</label>
                <small class="red-text">{{ errors.first('familia') }}</small>
              </div>
            </div>
          </div>

          <div class="row" v-show="familia.categorias.length > 0">
            <p><strong>Categorias</strong></p>
            <div class="input-field col s12">
                <div class="row" v-for="(categoria, index) in familia.categorias">
                  <div class="col s12 m11">
                    <input name="categoria" :id="`categoria${index}`" type="text" v-validate
                           data-vv-rules="required" :class="{invalid: errors.has('categoria')}"
                           v-model="categoria.categoria"/>
                  </div>
                  <div class="input-field col s12 m1">
                    <div class="right-align">
                      <a href="#" @click.prevent="destroyCategoria(index)">
                        <i class="material-icons red-text">delete_forever</i>
                      </a>
                    </div>
                  </div>
                </div>
            </div>
          </div>

          <div class="row">

            <div class="input-field col s12">
              <button type="button" class="waves-effect waves-light btn" :disabled="loading" @click.prevent="addCategoria()">Add Categoria</button>
            </div>

          </div>

          <div class="row">

            <div class="input-field col s12">
              <button class="waves-effect waves-light btn" :disabled="loading">Salvar</button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/familias/form.vue